import _ from 'lodash'

const filterNils = arr => arr.filter(item => !_.isNil(item))

const phoneStatusEx = {
  url: 'http://narus.com/fhir/extensions/phoneStatus'
}

export const phoneToFhir = formattedPhone =>
  formattedPhone && formattedPhone.replace(/[., -]+/g, '')

export const phonesToFhir = formattedPhones =>
  _.compact(formattedPhones).map(e => ({
    ...e,
    number: phoneToFhir(e.number)
  }))

export const faxMapping = () => {
  const faxObjectMap = [
    {
      fhir: [ 'value' ],
      form: [ 'number' ],
      to_fhir: v => phoneToFhir(v)
    },
    {
      fhir: [ 'use' ],
      form: [ 'faxType' ]
    },
    {
      fhir: [ 'rank' ],
      form: [ 'preferred' ],
      to_fhir: f => (f ? 1 : 2),
      to_form: f => f === 1
    },
    {
      fhir: [ 'extension', phoneStatusEx, 'valueCode' ],
      form: [ 'status' ]
    }
  ]

  return {
    $mapping: faxObjectMap,
    fhir: [
      'telecom',
      {
        $filter: { system: 'fax' },
        $collection: true
      }
    ],
    form: [ 'faxes', { $collection: true }],
    to_fhir: v => filterNils(v)
  }
}

export const phoneMapping = () => {
  const phoneObjectMap = [
    {
      fhir: [ 'value' ],
      form: [ 'number' ],
      to_fhir: v => phoneToFhir(v)
    },
    {
      fhir: [ 'use' ],
      form: [ 'phoneType' ]
    },
    {
      fhir: [ 'rank' ],
      form: [ 'preferred' ],
      to_fhir: f => (f ? 1 : 2),
      to_form: f => f === 1
    },
    {
      fhir: [ 'extension', phoneStatusEx, 'valueCode' ],
      form: [ 'status' ]
    }
  ]

  return {
    $mapping: phoneObjectMap,
    fhir: [
      'telecom',
      {
        $filter: { system: 'phone' },
        $collection: true
      }
    ],
    form: [ 'phones', { $collection: true }],
    to_fhir: v => filterNils(v)
  }
}

export const otherMapping = () => {
  const otherObjectMap = [
    {
      fhir: [ 'system' ],
      form: [ 'system' ]
    },
    {
      fhir: [ 'value' ],
      form: [ 'value' ]
    },
    {
      fhir: [ 'use' ],
      form: [ 'use' ]
    },
    {
      fhir: [ 'rank' ],
      form: [ 'rank' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/readonly' },
        'valueBoolean'
      ],
      form: [ 'readonly' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/source' },
        'valueString'
      ],
      form: [ 'source' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/batch' },
        'valueString'
      ],
      form: [ 'batch' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/listingName' },
        'valueString'
      ],
      form: [ 'listing_name' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/relationship' },
        'valueString'
      ],
      form: [ 'relationship' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/firstSeen' },
        'valueString'
      ],
      form: [ 'first_seen' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/lastSeen' },
        'valueString'
      ],
      form: [ 'last_seen' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/phoneType' },
        'valueString'
      ],
      form: [ 'phone_type' ]
    },
    {
      fhir: [
        'extension',
        { url: 'http://narus.com/fhir/extensions/lineType' },
        'valueString'
      ],
      form: [ 'line_type' ]
    }
  ]

  return {
    $mapping: otherObjectMap,
    fhir: [
      'telecom',
      {
        $filter: { system: 'other' },
        $collection: true
      }
    ],
    form: [ 'other', { $collection: true }]
  }
}
